import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { UserService } from "./core/auth/user.service";
import { SitesService } from "./core/sites";
import { PartnersService } from "./partner/global/partners.service";

export const AccountPendingGuard: CanActivateFn = async (): Promise<
  boolean | UrlTree
> => {
  const router = inject(Router);
  const user = inject(UserService);
  const partners = inject(PartnersService);
  const sites = inject(SitesService);

  // Wait until the user has been loaded (emit via isLoadedChanges) so we
  // can make a decision without the component being rendered prematurely.
  await firstValueFrom(user.isLoadedChanges);

  if ((await partners.load()) && (await sites.load())) {
    // If both partners and sites are already available, redirect to the app.
    return router.parseUrl("/");
  }

  // Otherwise allow the account-pending component to render so the user sees
  // the pending account notice.
  return true;
};
